import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { OutboundLink } from 'react-ga'
import SVG from 'react-inlinesvg'
import cx from 'clsx'
// Context
import GlobalContext from '~context/GlobalContext'
// Utils
import { getTwitterDescription } from '../Seo/Seo'
// Styles
import useStyles from './ShareIcon.style'
import { sendGTMEvent } from '../../../utils/googleAnalytics'

const ShareIcon = ({
  height,
  id,
  icon,
  socialTitle,
  title,
  url,
  width,
  detailFandomTitle,
  //   twitterHandle,
}) => {
  const { currentFandom, insideFandom } = useContext(GlobalContext)
  const classes = useStyles()
  let shareUrl = insideFandom ? currentFandom.url : url

  shareUrl = shareUrl.match(/\/$/) ? shareUrl : shareUrl + '/'

  // eslint-disable-next-line no-unused-vars
  let alt, socialUrl
  //   const twitterFandomTitle =
  //     detailFandomTitle &&
  //     twitterHandle &&
  //     detailFandomTitle.split(' ').join('') === twitterHandle.slice(1)
  //       ? twitterHandle + ' '
  //       : detailFandomTitle + ' '
  const twitterFandomTitle = detailFandomTitle + ' '

  switch (id) {
    case 'facebook':
      alt = insideFandom
        ? `Share ${currentFandom.title} on ${socialTitle}`
        : `alt for ${socialTitle}`
      socialUrl = `https://facebook.com/sharer/sharer.php?u=${shareUrl}&t=${encodeURIComponent(
        title
      )}`
      title = alt
      break
    case 'twitter':
      const twitterDescription = getTwitterDescription(
        !!detailFandomTitle,
        twitterFandomTitle
      )
      alt = insideFandom
        ? `Share ${currentFandom.title} on ${socialTitle}`
        : `alt for ${socialTitle}`
      socialUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        twitterDescription
      )}&hashtags=FandomsOfTheYear&url=${encodeURIComponent(shareUrl)}`
      title = alt
      break
    case 'pinterest':
      alt = insideFandom
        ? `Share ${currentFandom.title} on ${socialTitle}`
        : `alt for ${socialTitle}`
      socialUrl = `http://pinterest.com/pin/create/button/?url=${shareUrl}&description=${title}`
      title = alt
      break
    case 'whatsapp':
      alt = insideFandom
        ? `Share ${currentFandom.title} on ${socialTitle}`
        : `alt for ${socialTitle}`
      socialUrl = `https://wa.me/?text=${encodeURIComponent(shareUrl)}`
      title = alt
      break
    default:
      alt = null
      socialUrl = null
      title = null
  }

  if (!socialUrl) {
    return null
  }

  return (
    <OutboundLink
      className={cx(classes.socialLink)}
      to={socialUrl && socialUrl}
      onClick={() => sendGTMEvent('FanSided Fandoms share', id)}
      eventLabel={socialUrl && socialUrl}
      rel="noopener noreferrer nofollow"
      target="_blank"
    >
      <SVG
        src={icon}
        height={height}
        width={width}
        title={title}
        description={alt}
      />
      {alt && <span className="screen-reader-text">{alt}</span>}
    </OutboundLink>
  )
}

ShareIcon.propTypes = {
  height: PropTypes.number,
  id: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  width: PropTypes.number,
}

ShareIcon.defaultProps = {
  height: 28,
  id: '',
  title: 'FanSided 250',
  url: 'https://fansided.com',
  width: 28,
}

export default ShareIcon
